import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from 'utils/axios';
import AxiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

export const getFlights = createAsyncThunk('GET FLIGHTS', async (data, thunkAPI) => {

  let sorting = data.sorting === 'ascend' ? 'asc' : 'desc';

  let query = `?page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&booking_status=${data.bookingStatus}&currency=${data.currency}&payment_gateway=${data.paymentGateway}&payment_type=${data.paymentMethodTypes}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&sorting=${sorting}&sorting_field=${data.sortingField}&user_type=${data.userType}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&cogs_paid_date=${data.cogsPaidDate}&agency_id=${data?.agencyId}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}&provider_name=${data.consolidator}&aggregator=${data.vendor}&vendor_cogs_payment_mode=${data.cogsPaymentMode}`;

  //if (data?.agencyId) {
  //  query = `?agencyId=${data?.agencyId}&page=${data.page}&pageSize=${data.pageSize}&limit=${data.limit}&text=${data.text}&bookingStatus=${data.bookingStatus}&provider=${data.provider}&startDate=${data.startDate}&endDate=${data.endDate}&currency=${data.currency}&paymentGateway=${data.paymentGateway}&sorting=${data.sorting}&userType=${data.userType}&sortingField=${data.sortingField}&travelStartDate=${data.travelStartDate}&travelEndDate=${data.travelEndDate}&agencyName=${data.agencyName}&cogs=${data.cogs}&cogsPaidDate=${data.cogsPaidDate}&agencyCommissionPaid=${data.agencyCommissionPaid}&agencyCommissionPaidDate=${data.agencyCommissionPaidDate}&isNonLogin=${data.isNonLogin}`;
  //}
  const response = await AxiosAdmin.get(`${URL.FLIGHT}${query}`, thunkAPI);
  return response.data;
});

export const getFlightDetails = createAsyncThunk('GET FLIGHTS DETAILS', async (data, thunkAPI) => {
  const response = await AxiosAdmin.get(`${URL.FLIGHT}?id=${data.referenceNumber}`, thunkAPI);
  return response.data;
});

export const resendEmailConfirmation = createAsyncThunk(
  'RESEND_FLIGHT_EMAIL_CONFIRMATION',
  async ({ requestData, v2Version }, thunkAPI) => {
    if (v2Version) {
      const response = await AxiosAdmin.post(URL.RESEND_FLIGHT_CONFIRMATION_EMAIL_V2, requestData, thunkAPI);
      return response.data;
    } else {
      const response = await axios.post(URL.RESEND_FLIGHT_CONFIRMATION_EMAIL, requestData, thunkAPI);
      return response.data;
    }
  }
);

export const updateFlightRemark = createAsyncThunk('UPDATE_FLIGHT_REMARKS', async (data, thunkAPI) => {
  let requestData = {
    remark_id: data?.remark_id || "",
    remark: data?.remark,
  };
  const response = await AxiosAdmin.put(`${URL.BOOKING}?id=${data.referenceNumber}`, requestData, thunkAPI);
  return response.data;
});

export const updateFlightBooking = createAsyncThunk('UPDATE_FLIGHT_BOOKING', async (data, thunkAPI) => {
  const response = await AxiosAdmin.put(`${URL.BOOKING}?id=${data.referenceNumber}`, data, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  flightData: null,
  flightDetails: null,
};

export const flightSlice = createSlice({
  name: 'flight',
  initialState,
  reducers: {},
  extraReducers: {
    // get flights
    [getFlights.pending]: (state) => {
      state.isLoading = true;
      state.flightData = null;
    },
    [getFlights.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.flightData = action.payload.data;
    },
    [getFlights.rejected]: (state, action) => {
      state.isLoading = false;
      state.flightData = null;
      toast.error(action?.payload?.message);
    },

    // update flight remarks
    [updateFlightRemark.pending]: (state) => {
      state.isLoading = true;
    },
    [updateFlightRemark.fulfilled]: (state) => {
      state.isLoading = false;
      toast.success('Remarks updated successfully');
    },
    [updateFlightRemark.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating remarks');
    },
    // get flight Details
    [getFlightDetails.pending]: (state) => {
      state.isLoading = true;
      state.flightDetails = null;
    },
    [getFlightDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.flightDetails = action.payload.data;
    },
    [getFlightDetails.rejected]: (state, action) => {
      state.isLoading = false;
      state.flightDetails = null;
      toast.error(action?.payload?.message);
    },

    // resend hotel confirmation email
    [resendEmailConfirmation.pending]: (state) => {
      state.isLoading = true;
    },
    [resendEmailConfirmation.fulfilled]: (state) => {
      state.isLoading = false;
      // Handle success, e.g., show a success toast message
      toast.success('Email confirmation resent successfully');
    },
    [resendEmailConfirmation.rejected]: (state, action) => {
      state.isLoading = false;
      // Handle error, e.g., show an error toast message
      toast.error(action.payload?.error || 'Error resending email confirmation');
    },

    // update hotel booking
    [updateFlightBooking.pending]: (state) => {
      state.isLoading = true;
    },
    [updateFlightBooking.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload?.message);
    },
    [updateFlightBooking.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating cogs data');
    },
  },
});

export default flightSlice.reducer;
